import React, { useState } from 'react';

const mapFirebaseChildren = (snapshot, func) => {
  const result = [];
  let index = 1;
  snapshot.forEach(s => {
    result.push(func(s, index));
    index++;
  });
  return result;
};

const daysOfWeek = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

const militaryHourToUS = (hour) => {
  hour = Number(hour);
  if (hour === 0) return "12am";
  if (hour === 12) return "12pm";
  if (hour > 12) return `${hour-12}pm`;
  return `${hour}am`;
};


/* ========================= Time Editor ========================= */

function TimeEditor({ snapshot, isEditable }) {
  const hourS = snapshot.child("hour");
  const minS = snapshot.child("minute");

  if (!isEditable) {
    return (
      <div className="time-editor">
        {militaryHourToUS(hourS.val())} {minS.val()}min
      </div>
    );
  }

  return (
    <div className="time-editor">
      <select value={hourS.val() ?? ""} onChange={(e) => hourS.ref.set(e.target.value)}>
        <option value="">-</option>
        {[...Array(24).keys()].map(h => <option key={h} value={h}>{militaryHourToUS(h)}</option>)}
      </select>
      :
      <select value={minS.val() ?? ""} onChange={(e) => minS.ref.set(e.target.value)}>
        <option value="">-</option>
        {[...Array(60).keys()].map(m => <option key={m} value={m}>{m}</option>)}
      </select>
    </div>
  );
}


/* ========================= Time Range ========================= */

function TimeRangeEditor({ snapshot, isEditable }) {
  const fromS = snapshot.child("from");
  const toS   = snapshot.child("to");

  return (
    <div className="time-range-editor">
      <TimeEditor snapshot={fromS} isEditable={isEditable}/>
      <span className="arrow"> → </span>
      <TimeEditor snapshot={toS}   isEditable={isEditable}/>
      {isEditable && <button onClick={() => snapshot.ref.set(null)}>delete</button>}
    </div>
  );
}


/* ========================= Day Editor ========================= */

function DayOfWeekEditor({ snapshot, isEditable }) {

  const addRange = () => snapshot.ref.push({ lastModified: Date.now() });

  const copyFromDay = async (e) => {
    if (!e.target.value) return;
    const snap = await snapshot.ref.parent.child(e.target.value).once("value");
    snapshot.ref.set(snap.val());
  };

  return (
    <div className="day-of-week-editor">
      <div className="day-of-week">{snapshot.key}:</div>

      <div className="time-ranges">
        {!snapshot.val() && <div style={{color:"red"}} className="empty">empty</div>}
        {mapFirebaseChildren(snapshot, (child, i) =>
          <TimeRangeEditor key={child.key || i} snapshot={child} isEditable={isEditable}/>
        )}
      </div>

      {isEditable && <button onClick={addRange}>new range</button>}

      {isEditable && (
        <select onChange={copyFromDay}>
          <option value="">copy...</option>
          {daysOfWeek.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
      )}
    </div>
  );
}


/* ========================= MAIN COMPONENT ========================= */

function SnapScheduleEditor({ snapshot, summary }) {

  // summary → only sets INITIAL read-only state
  const [isEditable, setIsEditable] = useState(!summary);

  const timezoneValue = snapshot.child("timezone").val() || "none";

  const copySchedule = async (e) => {
    if (!e.target.value) return;
    const snap = await snapshot.ref.parent.child(e.target.value).once("value");
    snapshot.ref.set(snap.val());
  };

  const setTimezone = (e) => snapshot.child("timezone").ref.set(e.target.value);


  return (
    <div className="snap-schedule-editor">

      {/* TOGGLE BOTH WAYS */}
      <button onClick={() => setIsEditable(prev => !prev)}>
        {isEditable ? "Done" : "Edit"}
      </button>

      <br/>Timezone:
      {isEditable ? (
        <select value={timezoneValue} onChange={setTimezone}>
          <option value="none">select timezone</option>
          <option value="America/Los_Angeles">Pacific (LA)</option>
          <option value="America/Chicago">Central (Chicago)</option>
          <option value="America/Denver">Mountain (Denver)</option>
          <option value="America/New_York">Eastern (Miami)</option>
        </select>
      ) : timezoneValue}

      {daysOfWeek.map(day => (
        <DayOfWeekEditor
          key={day}
          snapshot={snapshot.child(day)}
          isEditable={isEditable}
        />
      ))}

      {isEditable && (
        <select onChange={copySchedule}>
          <option value="">copy schedule from...</option>
          {["dineIn","pickUp","delivery"].map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      )}
    </div>
  );
}

export default SnapScheduleEditor;